import { SHOW_SNACKBAR } from './constants';

export const showSnackbar = (payload: { message: string }) => ({
  type: SHOW_SNACKBAR,
  payload,
});
